import { DiscountResponseInterface } from '@/types/Discount';

export class Discount {
  activeFrom: null | string;
  activeTo: null | string;
  autoFromCount: number;
  code: string;
  createdAt: null | string;
  currency: null | string;
  fullOrderDiscount: boolean;
  isAutoDiscount: boolean;
  isCurrencyRestricted: boolean;
  isDateRestricted: boolean;
  isProductRestricted: boolean;
  isPromoterRestricted: boolean;
  isUserRestricted: boolean;
  name: string;
  promoterId: number;
  restrictedEmail: null | string;
  sku: null | string;
  type: string;
  updatedAt: null | string;
  useCount: null | number;
  useLimit: null | string;
  value: number;

  constructor({
    active_from,
    active_to,
    auto_from_count,
    code,
    created_at,
    currency,
    full_order_discount,
    is_auto_discount,
    is_currency_restricted,
    is_date_restricted,
    is_product_restricted,
    is_promoter_restricted,
    is_user_restricted,
    name,
    promoter_id,
    restricted_email,
    sku,
    type,
    updated_at,
    use_count,
    use_limit,
    value
  }: DiscountResponseInterface) {
    this.activeFrom = active_from;
    this.activeTo = active_to;
    this.autoFromCount = auto_from_count;
    this.code = code;
    this.createdAt = created_at;
    this.currency = currency;
    this.fullOrderDiscount = full_order_discount;
    this.isAutoDiscount = is_auto_discount;
    this.isCurrencyRestricted = is_currency_restricted;
    this.isDateRestricted = is_date_restricted;
    this.isProductRestricted = is_product_restricted;
    this.isPromoterRestricted = is_promoter_restricted;
    this.isUserRestricted = is_user_restricted;
    this.name = name;
    this.promoterId = promoter_id;
    this.restrictedEmail = restricted_email;
    this.sku = sku;
    this.type = type;
    this.updatedAt = updated_at;
    this.useCount = use_count;
    this.useLimit = use_limit;
    this.value = value;
  }
}
